// TODO: Replace mock data with WP REST API calls
// Endpoint patterns: /wp-json/shuddhoshikha/v1/courses, /wp/v2/users, etc.

export const courses = [
  {
    id: 1,
    title: "এসএসসি ২০২৭ - বাংলা ১ম পত্র",
    thumbnail:
      "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=120&h=80&fit=crop",
    category: "এসএসসি",
    price: 1500,
    author: "Sarah Johnson",
    authorAvatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop",
    date: "Mar 15, 2026",
    status: "Publish",
    topics: 8,
    lessons: 45,
    quizzes: 12,
    assignments: 6,
  },
  {
    id: 2,
    title: "এসএসসি ২০২৭ - গণিত",
    thumbnail:
      "https://images.unsplash.com/photo-1509228468518-180dd4864904?w=120&h=80&fit=crop",
    category: "এসএসসি",
    price: 1500,
    author: "মোঃ ইউসুফ (BUET)",
    authorAvatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop",
    date: "Mar 15, 2026",
    status: "Publish",
    topics: 10,
    lessons: 60,
    quizzes: 15,
    assignments: 8,
  },
  {
    id: 3,
    title: "এসএসসি ২০২৭ - পদার্থবিজ্ঞান",
    thumbnail:
      "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=120&h=80&fit=crop",
    category: "এসএসসি",
    price: 1500,
    author: "ইমরান হোসেন (BUET)",
    authorAvatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&h=80&fit=crop",
    date: "Mar 15, 2026",
    status: "Publish",
    topics: 9,
    lessons: 40,
    quizzes: 12,
    assignments: 5,
  },
  {
    id: 4,
    title: "এসএসসি ২০২৭ - রসায়ন",
    thumbnail:
      "https://images.unsplash.com/photo-1603126857599-f6e157fa2fe6?w=120&h=80&fit=crop",
    category: "এসএসসি",
    price: 1500,
    author: "Sarah Johnson",
    authorAvatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop",
    date: "Mar 12, 2026",
    status: "Publish",
    topics: 7,
    lessons: 35,
    quizzes: 10,
    assignments: 4,
  },
  {
    id: 5,
    title: "এসএসসি ২০২৭ - জীববিজ্ঞান",
    thumbnail:
      "https://images.unsplash.com/photo-1532187643603-ba119ca4109e?w=120&h=80&fit=crop",
    category: "এসএসসি",
    price: 1500,
    author: "Sarah Johnson",
    authorAvatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop",
    date: "Mar 12, 2026",
    status: "Publish",
    topics: 6,
    lessons: 38,
    quizzes: 8,
    assignments: 4,
  },
  {
    id: 6,
    title: "এসএসসি ২০২৭ - ইংরেজি ১ম পত্র",
    thumbnail:
      "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=120&h=80&fit=crop",
    category: "এসএসসি",
    price: 1500,
    author: "Sarah Johnson",
    authorAvatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop",
    date: "Mar 10, 2026",
    status: "Publish",
    topics: 8,
    lessons: 50,
    quizzes: 12,
    assignments: 5,
  },
  {
    id: 18,
    title: "অষ্টম শ্রেণি - বিজ্ঞান",
    thumbnail:
      "https://images.unsplash.com/photo-1507668077129-56e32842fceb?w=120&h=80&fit=crop",
    category: "অষ্টম শ্রেণি",
    price: 1200,
    author: "Sarah Johnson",
    authorAvatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop",
    date: "Mar 10, 2026",
    status: "Publish",
    topics: 5,
    lessons: 30,
    quizzes: 8,
    assignments: 4,
  },
  {
    id: 19,
    title: "অষ্টম শ্রেণি - গণিত",
    thumbnail:
      "https://images.unsplash.com/photo-1509228468518-180dd4864904?w=120&h=80&fit=crop",
    category: "অষ্টম শ্রেণি",
    price: 1200,
    author: "মোঃ ইউসুফ (BUET)",
    authorAvatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop",
    date: "Mar 8, 2026",
    status: "Publish",
    topics: 6,
    lessons: 45,
    quizzes: 10,
    assignments: 5,
  },
  {
    id: 20,
    title: "সপ্তম শ্রেণি - গণিত",
    thumbnail:
      "https://images.unsplash.com/photo-1509228468518-180dd4864904?w=120&h=80&fit=crop",
    category: "সপ্তম শ্রেণি",
    price: 1000,
    author: "মোঃ ইউসুফ (BUET)",
    authorAvatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop",
    date: "Mar 5, 2026",
    status: "Publish",
    topics: 5,
    lessons: 40,
    quizzes: 8,
    assignments: 4,
  },
  {
    id: 21,
    title: "সপ্তম শ্রেণি - বিজ্ঞান",
    thumbnail:
      "https://images.unsplash.com/photo-1507668077129-56e32842fceb?w=120&h=80&fit=crop",
    category: "সপ্তম শ্রেণি",
    price: 1000,
    author: "Sarah Johnson",
    authorAvatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop",
    date: "Mar 5, 2026",
    status: "Publish",
    topics: 4,
    lessons: 36,
    quizzes: 8,
    assignments: 3,
  },
  {
    id: 22,
    title: "ষষ্ঠ শ্রেণি - গণিত",
    thumbnail:
      "https://images.unsplash.com/photo-1509228468518-180dd4864904?w=120&h=80&fit=crop",
    category: "ষষ্ঠ শ্রেণি",
    price: 800,
    author: "মোঃ ইউসুফ (BUET)",
    authorAvatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop",
    date: "Mar 1, 2026",
    status: "Publish",
    topics: 5,
    lessons: 35,
    quizzes: 8,
    assignments: 4,
  },
  {
    id: 23,
    title: "ষষ্ঠ শ্রেণি - ইংরেজি",
    thumbnail:
      "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=120&h=80&fit=crop",
    category: "ষষ্ঠ শ্রেণি",
    price: 800,
    author: "Sarah Johnson",
    authorAvatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop",
    date: "Mar 1, 2026",
    status: "Publish",
    topics: 4,
    lessons: 24,
    quizzes: 6,
    assignments: 2,
  },
];

export const students = [
  {
    id: 1,
    name: "Alexandra Smith",
    email: "alex.smith@example.com",
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=80&h=80&fit=crop",
    registrationDate: "Mar 18, 2026",
    courses: ["এসএসসি ২০২৭ - গণিত", "এসএসসি ২০২৭ - পদার্থবিজ্ঞান"],
  },
  {
    id: 2,
    name: "James Anderson",
    email: "james.a@example.com",
    avatar:
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=80&h=80&fit=crop",
    registrationDate: "Mar 16, 2026",
    courses: ["অষ্টম শ্রেণি - বিজ্ঞান"],
  },
  {
    id: 3,
    name: "Maria Garcia",
    email: "maria.g@example.com",
    avatar:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=80&h=80&fit=crop",
    registrationDate: "Mar 14, 2026",
    courses: ["সপ্তম শ্রেণি - গণিত", "ষষ্ঠ শ্রেণি - ইংরেজি"],
  },
  {
    id: 4,
    name: "David Kim",
    email: "david.kim@example.com",
    avatar:
      "https://images.unsplash.com/photo-1507591064344-4c6ce005b128?w=80&h=80&fit=crop",
    registrationDate: "Mar 12, 2026",
    courses: ["এসএসসি ২০২৭ - বাংলা ১ম পত্র"],
  },
  {
    id: 5,
    name: "Sophie Martinez",
    email: "sophie.m@example.com",
    avatar:
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=80&h=80&fit=crop",
    registrationDate: "Mar 10, 2026",
    courses: ["এসএসসি ২০২৭ - জীববিজ্ঞান", "অষ্টম শ্রেণি - গণিত"],
  },
];

export const zoomMeetings = [
  {
    id: 1,
    title: "Live Q&A: এসএসসি ২০২৭ - গণিত",
    meetingId: "123 456 7890",
    course: "এসএসসি ২০২৭ - গণিত",
    date: "Mar 20, 2026",
    time: "10:00 AM - 11:30 AM",
    status: "Live",
    joinUrl: "https://zoom.us/j/1234567890",
  },
  {
    id: 2,
    title: "পদার্থবিজ্ঞান - জটিল সৃজনশীল সমাধান ক্লাস",
    meetingId: "098 765 4321",
    course: "এসএসসি ২০২৭ - পদার্থবিজ্ঞান",
    date: "Mar 22, 2026",
    time: "2:00 PM - 3:30 PM",
    status: "Upcoming",
    joinUrl: "https://zoom.us/j/0987654321",
  },
  {
    id: 3,
    title: "অষ্টম শ্রেণি বিজ্ঞান - প্রজেক্ট ও রিভিশন",
    meetingId: "567 890 1234",
    course: "অষ্টম শ্রেণি - বিজ্ঞান",
    date: "Mar 18, 2026",
    time: "11:00 AM - 12:00 PM",
    status: "Expired",
    joinUrl: "https://zoom.us/j/5678901234",
  },
  {
    id: 4,
    title: "ষষ্ঠ শ্রেণি গণিত - রুটিন ও সিলেবাস ওয়ার্কশপ",
    meetingId: "432 109 8765",
    course: "ষষ্ঠ শ্রেণি - গণিত",
    date: "Mar 25, 2026",
    time: "9:00 AM - 11:00 AM",
    status: "Upcoming",
    joinUrl: "https://zoom.us/j/4321098765",
  },
];

export const instructors = [
  {
    id: 1,
    name: "Sarah Johnson",
    email: "sarah.j@shuddhoshikha.com",
    avatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop",
    assignedCourses: [
      "এসএসসি ২০২৭ - বাংলা ১ম পত্র",
      "এসএসসি ২০২৭ - রসায়ন",
      "এসএসসি ২০২৭ - জীববিজ্ঞান",
      "এসএসসি ২০২৭ - ইংরেজি ১ম পত্র",
    ],
    totalStudents: 187,
    revenueShare: 70,
    registrationDate: "Jan 5, 2026",
    status: "Active",
  },
  {
    id: 2,
    name: "মোঃ ইউসুফ (BUET)",
    email: "yusuf.buet@shuddhoshikha.com",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop",
    assignedCourses: [
      "এসএসসি ২০২৭ - গণিত",
      "অষ্টম শ্রেণি - গণিত",
      "সপ্তম শ্রেণি - গণিত",
      "ষষ্ঠ শ্রেণি - গণিত",
    ],
    totalStudents: 234,
    revenueShare: 75,
    registrationDate: "Jan 12, 2026",
    status: "Active",
  },
  {
    id: 3,
    name: "ইমরান হোসেন (BUET)",
    email: "imran.buet@shuddhoshikha.com",
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&h=80&fit=crop",
    assignedCourses: ["এসএসসি ২০২৭ - পদার্থবিজ্ঞান"],
    totalStudents: 95,
    revenueShare: 65,
    registrationDate: "Feb 1, 2026",
    status: "Active",
  },
  {
    id: 4,
    name: "Dr. Nafisa Rahman",
    email: "nafisa.r@shuddhoshikha.com",
    avatar:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=80&h=80&fit=crop",
    assignedCourses: [
      "অষ্টম শ্রেণি - বিজ্ঞান",
      "সপ্তম শ্রেণি - বিজ্ঞান",
    ],
    totalStudents: 142,
    revenueShare: 70,
    registrationDate: "Feb 15, 2026",
    status: "Active",
  },
  {
    id: 5,
    name: "Kamal Hossain",
    email: "kamal.h@shuddhoshikha.com",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop",
    assignedCourses: ["ষষ্ঠ শ্রেণি - ইংরেজি"],
    totalStudents: 56,
    revenueShare: 60,
    registrationDate: "Mar 1, 2026",
    status: "Inactive",
  },
];
